import { render, staticRenderFns } from "./TopBtn.vue?vue&type=template&id=e4fdfeb6&scoped=true&"
import script from "./TopBtn.vue?vue&type=script&lang=ts&"
export * from "./TopBtn.vue?vue&type=script&lang=ts&"
import style0 from "./TopBtn.vue?vue&type=style&index=0&id=e4fdfeb6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4fdfeb6",
  null
  
)

export default component.exports